// @flow

import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link'
import { withRouter } from 'react-router-dom'
import { UilAngleRightB } from '@iconscout/react-unicons'
import { fetchArticlesData } from '../../actions/learn'

type Props = {
  globalGetLanguages: string,
  articlesData: any,
  articlesDataError: boolean,
  fetchArticlesData: () => void,
  history: any,
  closeDropdown?: () => void
}

const DropdownUni = ({ globalGetLanguages, articlesData, articlesDataError, fetchArticlesData, history, closeDropdown }: Props) => {
  const [activeSection, setActiveSection] = useState('programs')
  const [apiData, setApiData] = useState({
    university: null
  })

  // Fetch API data on component mount and update local state when Redux data changes
  useEffect(() => {
    fetchArticlesData()
  }, [fetchArticlesData])

  useEffect(() => {
    if (articlesData && articlesData.size > 0) {
      const articlesDataJS = articlesData.toJS()
      if (articlesDataJS.university) {
        setApiData({ university: articlesDataJS.university })
      }
    }
  }, [articlesData])

  // Define content for each section
  const contentSections = {
    programs: {
      leftColumn: {
        title: null,
        links: [
          { to: '/admissions', text: 'Admissions' },
        ]
      },
      rightColumn: {
        title: null,
        links: [
          { to: '/career-center', text: 'Career Center' },
        ]
      }
    }
  }

  const currentContent = contentSections[activeSection]

  return (
        <section>
          <li className="head-drop-page-link">
            <a 
              className={activeSection === 'programs' ? 'active' : ''}
              onMouseEnter={() => setActiveSection('programs')}
            >
              Solutions & Use Cases <UilAngleRightB/>
            </a>
          </li>
          <li className="link-middle">
            {currentContent.leftColumn.title && <h2>{currentContent.leftColumn.title}</h2>}
            {currentContent.leftColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          <li className="link-middle">
            {currentContent.rightColumn.title ? 
              <h2>{currentContent.rightColumn.title}</h2> : 
              (activeSection === 'campus' ? <h2>&nbsp;</h2> : null)
            }
            {currentContent.rightColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          {apiData.university != null && (
            <li className="link-with-img" onClick={() => {
              history.push(`/learn-detail/${apiData.university.id}`)
              if (closeDropdown) closeDropdown()
            }}>
              <img src={apiData.university.image_url} alt={apiData.university.title} />
              <h4>{apiData.university.title}</h4>
              <p>{apiData.university.desc}</p>
            </li>
          )}
        </section>
  )
}

const mapStateToProps = (state) => ({
  articlesData: state.articlesData,
  articlesDataError: state.articlesDataError
})

const mapDispatchToProps = {
  fetchArticlesData
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropdownUni))